var _ellipse, _g, _g2, _g3, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path2, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullLogoFatturami(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3014,
    height: 544,
    viewBox: "0 0 3014 544",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 320,
    cy: 272,
    rx: 241.994,
    ry: 242.943,
    fill: "#DEC49C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_830_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.415 256.968L266.771 314.556C268.562 316.323 271.444 316.31 273.218 314.526L420.092 166.858C422.958 163.977 420.917 159.07 416.854 159.07L300.079 159.07C298.853 159.07 297.679 159.562 296.82 160.437L208.364 250.516C206.599 252.313 206.622 255.199 208.415 256.968Z",
    fill: "#B2B6BD"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_830_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M431.585 286.689L373.228 229.1C371.438 227.333 368.556 227.347 366.782 229.13L219.908 376.798C217.042 379.679 219.083 384.587 223.146 384.587H339.921C341.146 384.587 342.321 384.094 343.18 383.22L431.636 293.14C433.4 291.344 433.378 288.458 431.585 286.689Z",
    fill: "#13457C"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dddd_830_22)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320 514.943C454.173 514.943 562.943 406.173 562.943 272C562.943 137.826 454.173 29.0571 320 29.0571C185.826 29.0571 77.0571 137.826 77.0571 272C77.0571 406.173 185.826 514.943 320 514.943ZM320 495.014C443.167 495.014 543.014 395.167 543.014 272C543.014 148.833 443.167 48.9861 320 48.9861C196.833 48.9861 96.986 148.833 96.986 272C96.986 395.167 196.833 495.014 320 495.014Z",
    fill: "#BA9559"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M257.784 85.1771C296.38 72.6496 337.904 72.3518 376.676 84.3242L374.178 92.4123C356.603 86.9916 337.931 84.0732 318.577 84.0732C298.273 84.0732 278.72 87.2849 260.397 93.2279L257.784 85.1771ZM197.753 127.912L192.295 121.382C164.16 144.896 143.15 175.799 131.63 210.61C120.111 245.421 118.539 282.757 127.093 318.413C135.647 354.068 153.987 386.627 180.046 412.423C206.106 438.218 238.85 456.225 274.591 464.416L276.484 456.156C192.696 437.034 130.175 362.056 130.175 272.474C130.175 214.405 156.447 162.472 197.753 127.912ZM506.708 262.306C506.887 265.673 506.978 269.063 506.978 272.474C506.978 363.873 441.894 440.071 355.544 457.25L357.208 465.565C403.635 456.276 445.162 430.57 474.179 393.156C503.196 355.742 517.762 309.126 515.206 261.847L506.708 262.306ZM425.334 117.219C453.315 136.495 475.827 163.141 490.068 194.353L497.775 190.842C482.965 158.33 459.588 130.459 430.149 110.217L425.334 117.219Z",
    fill: "#3C84C0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 352.638,
    cy: 461.94,
    r: 7.4509,
    fill: "#3C84C0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.234,
    cy: 121.328,
    r: 7.4509,
    fill: "#3C84C0"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 379.248,
    cy: 88.3308,
    r: 7.4509,
    fill: "#3C84C0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 495.269,
    cy: 194.772,
    r: 7.4509,
    fill: "#3C84C0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 511.236,
    cy: 256.508,
    r: 5.32207,
    stroke: "#3C84C0",
    strokeWidth: 4.25766
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.258,
    cy: 461.94,
    r: 5.32207,
    stroke: "#3C84C0",
    strokeWidth: 4.25766
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.647,
    cy: 91.5241,
    r: 5.32207,
    stroke: "#3C84C0",
    strokeWidth: 4.25766
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 423.954,
    cy: 109.619,
    r: 5.32207,
    stroke: "#3C84C0",
    strokeWidth: 4.25766
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.259 122.129C209.61 135.388 190.262 153.608 175.666 175.42L183.471 180.643C213.123 136.94 263.209 108.226 320 108.226C367.566 108.226 410.427 128.369 440.519 160.59L447.525 154.114C429.71 134.842 407.759 119.859 383.321 110.29C358.884 100.72 332.595 96.8143 306.431 98.8649C280.267 100.916 254.907 108.869 232.259 122.129ZM161.047 229.16L152.317 226.808C143.727 258.682 144.399 292.345 154.255 323.851C164.111 355.357 182.743 383.401 207.967 404.697C233.191 425.993 263.963 439.659 296.675 444.093C329.388 448.526 362.687 443.545 392.67 429.731L389.424 422.686C368.324 432.496 344.802 437.972 320 437.972C228.943 437.972 155.127 364.156 155.127 273.099C155.127 257.883 157.188 243.149 161.047 229.16ZM447.228 377.968L453.442 383.144C474.9 357.382 488.442 325.958 492.432 292.669C496.422 259.379 490.691 225.645 475.929 195.541L467.63 199.611C478.665 221.737 484.873 246.693 484.873 273.099C484.873 312.934 470.746 349.469 447.228 377.968Z",
    fill: "#3C84C0"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.326,
    cy: 224.737,
    r: 8.79322,
    fill: "#3C84C0"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.502,
    cy: 159.887,
    r: 8.79322,
    fill: "#3C84C0"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 447.502,
    cy: 385.213,
    r: 8.79322,
    fill: "#3C84C0"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 469.485,
    cy: 191.762,
    r: 6.59491,
    stroke: "#3C84C0",
    strokeWidth: 4.39661
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.011,
    cy: 182.969,
    r: 6.59491,
    stroke: "#3C84C0",
    strokeWidth: 4.39661
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 396.941,
    cy: 423.683,
    r: 6.59491,
    stroke: "#3C84C0",
    strokeWidth: 4.39661
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M923.85 320.075H826.95V431H775.95V142H936.6V190.875H826.95V271.2H923.85V320.075ZM1175.12 433.125C1160.67 433.125 1149.06 430.15 1140.27 424.2C1131.77 418.25 1125.54 410.883 1121.57 402.1C1109.39 413.433 1097.63 421.792 1086.3 427.175C1074.97 432.558 1062.78 435.25 1049.75 435.25C1030.77 435.25 1016.74 429.158 1007.67 416.975C998.891 404.792 994.5 389.35 994.5 370.65C994.5 358.183 996.766 347.275 1001.3 337.925C1006.12 328.292 1013.91 320.783 1024.67 315.4C1035.44 310.017 1050.17 307.325 1068.87 307.325C1076.24 307.325 1083.89 307.892 1091.82 309.025C1099.76 309.875 1107.69 311.008 1115.62 312.425V287.35C1115.62 275.45 1112.37 267.375 1105.85 263.125C1099.33 258.592 1090.55 256.325 1079.5 256.325C1071 256.325 1061.65 257.458 1051.45 259.725C1041.53 261.992 1030.77 265.533 1019.15 270.35L1005.12 228.7C1033.74 217.083 1059.67 211.275 1082.9 211.275C1103.87 211.275 1120.02 214.817 1131.35 221.9C1142.97 228.983 1151.04 238.333 1155.57 249.95C1160.11 261.567 1162.37 274.033 1162.37 287.35V370.225C1162.37 374.475 1163.51 378.583 1165.77 382.55C1168.32 386.233 1173.14 388.075 1180.22 388.075H1184.9V433.125H1175.12ZM1041.67 369.8C1041.67 377.45 1043.37 383.542 1046.77 388.075C1050.17 392.325 1055.13 394.45 1061.65 394.45C1068.17 394.45 1075.53 392.75 1083.75 389.35C1091.97 385.95 1102.59 378.017 1115.62 365.55V347.275C1100.89 344.725 1086.44 343.45 1072.27 343.45C1061.22 343.45 1053.29 345.717 1048.47 350.25C1043.94 354.783 1041.67 361.3 1041.67 369.8ZM1390.95 423.775C1383.59 427.175 1375.09 429.867 1365.45 431.85C1355.82 434.117 1346.05 435.25 1336.13 435.25C1319.7 435.25 1306.52 431.85 1296.6 425.05C1286.69 418.25 1279.46 408.758 1274.93 396.575C1270.68 384.392 1268.55 370.508 1268.55 354.925V258.025H1233.7V215.525H1268.55V159.425H1317.43V215.525H1384.58V258.025H1317.43V354.925C1317.43 367.958 1319.84 377.025 1324.65 382.125C1329.75 386.942 1336.98 389.35 1346.33 389.35C1350.86 389.35 1355.68 388.925 1360.78 388.075C1366.16 386.942 1372.11 385.1 1378.63 382.55L1390.95 423.775ZM1593.88 423.775C1586.51 427.175 1578.01 429.867 1568.38 431.85C1558.74 434.117 1548.97 435.25 1539.05 435.25C1522.62 435.25 1509.44 431.85 1499.53 425.05C1489.61 418.25 1482.38 408.758 1477.85 396.575C1473.6 384.392 1471.48 370.508 1471.48 354.925V258.025H1436.63V215.525H1471.48V159.425H1520.35V215.525H1587.5V258.025H1520.35V354.925C1520.35 367.958 1522.76 377.025 1527.58 382.125C1532.68 386.942 1539.9 389.35 1549.25 389.35C1553.78 389.35 1558.6 388.925 1563.7 388.075C1569.08 386.942 1575.03 385.1 1581.55 382.55L1593.88 423.775ZM1795.52 431V402.525C1782.49 413.858 1770.31 422.217 1758.97 427.6C1747.64 432.7 1736.16 435.25 1724.55 435.25C1705.28 435.25 1690.41 428.733 1679.92 415.7C1669.44 402.383 1664.2 383.825 1664.2 360.025V215.525H1713.07V354.075C1713.07 377.875 1721.86 389.775 1739.42 389.775C1746.51 389.775 1754.16 388.075 1762.37 384.675C1770.87 381.275 1781.07 374.758 1792.97 365.125V215.525H1841.85V431H1795.52ZM2064.69 260.15C2051.37 260.15 2038.62 262.275 2026.44 266.525C2014.54 270.492 2003.06 277.008 1992.01 286.075V431H1943.14V215.525H1989.46V248.675C2003.91 235.075 2016.81 225.442 2028.14 219.775C2039.47 214.108 2051.66 211.275 2064.69 211.275V260.15ZM2304.69 433.125C2290.24 433.125 2278.63 430.15 2269.84 424.2C2261.34 418.25 2255.11 410.883 2251.14 402.1C2238.96 413.433 2227.2 421.792 2215.87 427.175C2204.54 432.558 2192.35 435.25 2179.32 435.25C2160.34 435.25 2146.31 429.158 2137.24 416.975C2128.46 404.792 2124.07 389.35 2124.07 370.65C2124.07 358.183 2126.34 347.275 2130.87 337.925C2135.69 328.292 2143.48 320.783 2154.24 315.4C2165.01 310.017 2179.74 307.325 2198.44 307.325C2205.81 307.325 2213.46 307.892 2221.39 309.025C2229.33 309.875 2237.26 311.008 2245.19 312.425V287.35C2245.19 275.45 2241.94 267.375 2235.42 263.125C2228.9 258.592 2220.12 256.325 2209.07 256.325C2200.57 256.325 2191.22 257.458 2181.02 259.725C2171.1 261.992 2160.34 265.533 2148.72 270.35L2134.69 228.7C2163.31 217.083 2189.24 211.275 2212.47 211.275C2233.44 211.275 2249.59 214.817 2260.92 221.9C2272.54 228.983 2280.61 238.333 2285.14 249.95C2289.68 261.567 2291.94 274.033 2291.94 287.35V370.225C2291.94 374.475 2293.08 378.583 2295.34 382.55C2297.89 386.233 2302.71 388.075 2309.79 388.075H2314.47V433.125H2304.69ZM2171.24 369.8C2171.24 377.45 2172.94 383.542 2176.34 388.075C2179.74 392.325 2184.7 394.45 2191.22 394.45C2197.74 394.45 2205.1 392.75 2213.32 389.35C2221.54 385.95 2232.16 378.017 2245.19 365.55V347.275C2230.46 344.725 2216.01 343.45 2201.84 343.45C2190.79 343.45 2182.86 345.717 2178.04 350.25C2173.51 354.783 2171.24 361.3 2171.24 369.8Z",
    fill: "#21629B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2439.78 281.825V431H2390.9V215.525H2437.23V244C2450.54 232.383 2462.87 224.025 2474.2 218.925C2485.53 213.825 2497.15 211.275 2509.05 211.275C2535.4 211.275 2553.39 222.892 2563.03 246.125C2577.19 233.658 2590.37 224.733 2602.55 219.35C2614.73 213.967 2627.06 211.275 2639.53 211.275C2659.36 211.275 2674.52 217.933 2685 231.25C2695.48 244.283 2700.73 262.7 2700.73 286.5V431H2651.85V292.45C2651.85 268.65 2642.78 256.75 2624.65 256.75C2617.57 256.75 2609.78 258.45 2601.28 261.85C2592.78 265.25 2582.43 271.908 2570.25 281.825V431H2521.38V292.45C2521.38 268.65 2512.31 256.75 2494.18 256.75C2487.09 256.75 2479.3 258.45 2470.8 261.85C2462.3 265.25 2451.96 271.908 2439.78 281.825ZM2849.42 174.725H2797.99V124.15H2849.42V174.725ZM2848.14 431H2799.27V215.525H2848.14V431Z",
    fill: "#B2B6BD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_830_22",
    x: 207.055,
    y: 159.07,
    width: 214.375,
    height: 161.796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.99254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_830_22"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_830_22",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_830_22",
    x: 218.569,
    y: 227.784,
    width: 214.375,
    height: 161.796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.99254
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_830_22"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_830_22",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dddd_830_22",
    x: 71.3632,
    y: 23.3632,
    width: 497.273,
    height: 497.273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3.79598
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.948995
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_830_22"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.79598
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.948995
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_830_22",
    result: "effect2_dropShadow_830_22"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.79598
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.948995
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_830_22",
    result: "effect3_dropShadow_830_22"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.79598
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.948995
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_830_22",
    result: "effect4_dropShadow_830_22"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_830_22",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullLogoFatturami);
export default __webpack_public_path__ + "static/media/full-logo-fatturami.ce7741755f8ec87c645df8f26b0643ca.svg";
export { ForwardRef as ReactComponent };